module.exports = __webpack_public_path__ + "../resources/img/social-login-apple.7d7fcf9b.svg";